import React, { useCallback } from "react";
import {  Grid  } from "semantic-ui-react";
import InputField from "@commonComponents/formComponents/CustomInputField";
import DeleteIcon from "@commonComponents/deleteIcon";
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import { useSelector } from "react-redux";
import { selectMotList } from "../selectors";


export const TransportModeForm=React.memo(({dataSource:{id,modeOfTransport,type,identification,nationality},motTypeList=[],tableName,onChange,onBlur,onSelect,deleteData,countryList,isRepeatable=true,validateErrors})=>{
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>
  {
    onSelect(id,tableName,{[name]:value,id}),[tableName,id,onSelect,validateErrors]
      validateErrors && validateErrors()
  }
  )
  const onBlurHandler=useCallback(({target:{value,name}})=>{
    onBlur(tableName,{[name]:value,id})
    validateErrors && validateErrors()
  },[tableName,id,onBlur])
  
  const motList=useSelector(selectMotList)
 return (
  <>
    <Grid.Row>
    <Grid.Column>
    <DropDown
          id={`${tableName}-${id}-modeOfTransport`}
          label="MOT"
          name="modeOfTransport"
          clearable
          labelClass="text-none"
          data={motList}
          onChange={onDropDownChange}
          value={modeOfTransport}
          text={modeOfTransport}
          />
    </Grid.Column>
   
    <Grid.Column>
    <DropDown
          id={`${tableName}-${id}-type`}
          label="MOT_TYPE"
          name="type"
          labelClass="text-none"
          clearable
          data={motTypeList}
          onChange={onDropDownChange}
          value={type}
          text={type}
          />
    </Grid.Column>
    <Grid.Column>
    <InputField
        id={`${tableName}-${id}-identification`}
        name="identification"
        type="text"
        clearInput={false}
        label="MOT_IDENTIFICATION"
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        value={identification}
      />
    </Grid.Column>
    <Grid.Column>
    <DropDown
          id={`${tableName}-${id}-nationality`}
          label="NATIONALITY"
          name="nationality"
          labelClass="text-none"
          clearable
          data={countryList}
          onChange={onDropDownChange}
          value={nationality}
          text={nationality}
          />

    </Grid.Column>
  </Grid.Row>
 { isRepeatable && <div className="actionbtns">
       <DeleteIcon onClick={()=>deleteData(id,tableName)} />
    </div>
}
  </>
  )
})
TransportModeForm.defaultProps = {
  dataSource:{}
}